import 'react-app-polyfill/ie11';
import './vendor';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import createStore from './createStore';
import App from './App';
import '../assets/styles/application.scss';

export function initApplication() {
  render(
    <Provider store={createStore()}>
      <Router>
        <App />
      </Router>
    </Provider>,
    document.getElementById('root'),
  );
}
